import { Pipe } from '@angular/core';
import { isArray, sum } from '../utils/utils';
var SumPipe = (function () {
    function SumPipe() {
    }
    SumPipe.prototype.transform = function (input) {
        return !isArray(input) ? input : sum(input);
    };
    return SumPipe;
}());
export { SumPipe };
SumPipe.decorators = [
    { type: Pipe, args: [{ name: 'sum' },] },
];
/** @nocollapse */
SumPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=sum.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/aggregate/sum.pipe.js
// module id = 226
// module chunks = 103